import { render, staticRenderFns } from "./AppliedAllocation.vue?vue&type=template&id=460dfea8&scoped=true"
import script from "./AppliedAllocation.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppliedAllocation.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./AppliedAllocation.vue?vue&type=style&index=0&id=460dfea8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460dfea8",
  null
  
)

export default component.exports